import cx from 'classnames';
import React, { useContext } from 'react';
import { PortNetWorkType } from '../../../../../../../model/DeviceAdminModel';
import { IPv4AddressInput } from '../../../../../../common/IPv4AddressInput/IPv4AddressInput';
import { IPv6AddressInput } from '../../../../../../common/IPv6AddressInput/IPv6AddressInput';
import { PortStoreContext, setIPAddress, setIPv6Address, setLocalIPAddress, setLocalIPv6Address, setPortChangedAction } from '../../../contextPort';
import styles from '../../../portModal.module.scss';

type Props = {
	ipAddressValidation: boolean;
	onResetIPAddressValidation: () => void;
	errorMessage: string;
	onResetErrorMessage: () => void;
	useAdvancedAddress?: boolean;
};

const IPAddress: React.FC<Props> = ({ ipAddressValidation, onResetIPAddressValidation, errorMessage, onResetErrorMessage, useAdvancedAddress = false }) => {
	//region: State Management Variables
	const {
		portState,
		portState: { portNetworkType, hasPortChanged },
		dispatcher,
	} = useContext(PortStoreContext);

	const ipAddress = portState[!useAdvancedAddress ? 'ipAddress' : 'localIPAddress'];
	const ipv6Address = portState[!useAdvancedAddress ? 'ipv6Address' : 'localIPv6Address'];
	//endregion

	const checkIfPortChanged = () => {
		if (!hasPortChanged) {
			dispatcher(setPortChangedAction(true));
		}
	};

	const resetErrorMessages = () => {
		onResetIPAddressValidation();
		onResetErrorMessage();
	};

	const handleIPv6Change = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.currentTarget.value;
		resetErrorMessages();
		checkIfPortChanged();
		if (!useAdvancedAddress) {
			dispatcher(setIPv6Address(value));
		} else {
			dispatcher(setLocalIPv6Address(value));
		}
	};

	const handleIPv4Change = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.currentTarget.value;
		resetErrorMessages();
		checkIfPortChanged();
		if (!useAdvancedAddress) {
			dispatcher(setIPAddress(value));
		} else {
			dispatcher(setLocalIPAddress(value));
		}
	};

	const portGeneralIPv6AddressInputId = !useAdvancedAddress ? 'portGeneralIPv6AddressInput' : 'portAdvancedIPv6AddressInput';
	const portGeneralIPv4AddressInputId = !useAdvancedAddress ? 'portGeneralIPv4AddressInput' : 'portAdvancedIPv4AddressInput';

	return (
		<>
			<div
				className={cx(styles.inputContainer, {
					[styles.advancedIPAddressContainer]: useAdvancedAddress,
				})}>
				<label
					id={!useAdvancedAddress ? 'portGeneralIPAddressLabel' : 'portAdvancedIPAddressLabel'}
					htmlFor={portNetworkType === PortNetWorkType.IPv6 ? portGeneralIPv6AddressInputId : portGeneralIPv4AddressInputId}>
					{!useAdvancedAddress ? _('IPAddress') : <strong>{_('SNIB3IPAddress')}</strong>}
				</label>
				{portNetworkType === PortNetWorkType.IPv6 ? (
					<IPv6AddressInput
						id={portGeneralIPv6AddressInputId}
						key='ipv6Address'
						addressValidation={ipAddressValidation}
						value={ipv6Address}
						onChange={handleIPv6Change}
					/>
				) : (
					<IPv4AddressInput
						id={portGeneralIPv4AddressInputId}
						key='ipv4Address'
						addressValidation={ipAddressValidation}
						value={ipAddress}
						onChange={handleIPv4Change}
					/>
				)}
			</div>
			<div
				className={cx('', {
					[styles.inputValidation]: !useAdvancedAddress,
				})}>
				{ipAddressValidation && (
					<label
						id={!useAdvancedAddress ? 'portGeneralIPAddressErrorLabel' : 'portAdvancedIPAddressErrorLabel'}
						htmlFor={portNetworkType === PortNetWorkType.IPv6 ? portGeneralIPv6AddressInputId : portGeneralIPv4AddressInputId}
						className={cx(styles.errorMessage, {
							[styles.advancedErrorMessage]: useAdvancedAddress,
						})}>
						{errorMessage}
					</label>
				)}
			</div>
		</>
	);
};

export { IPAddress };
